
namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass()
    export class ReportPartDialog extends Serenity.EntityDialog<ReportPartRow, any> {
        protected getFormKey() { return ReportPartForm.formKey; }
        protected getIdProperty() { return ReportPartRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPartRow.localTextPrefix; }
        protected getNameProperty() { return ReportPartRow.nameProperty; }
        protected getService() { return ReportPartService.baseUrl; }
        protected getDeletePermission() { return ReportPartRow.deletePermission; }
        protected getInsertPermission() { return ReportPartRow.insertPermission; }
        protected getUpdatePermission() { return ReportPartRow.updatePermission; }

        protected form = new ReportPartForm(this.idPrefix);

    }
}